import { useMemo } from "react";
import { localeForLanguage, translate, type I18nKey } from "./language.js";
import { useSettingsStore } from "../stores/settings.store.js";

export function useI18n() {
  const language = useSettingsStore((s) => s.language);
  return useMemo(() => ({
    language,
    locale: localeForLanguage(language),
    t: (key: I18nKey, vars?: Record<string, string | number | null | undefined>) => translate(language, key, vars),
  }), [language]);
}
